<template>
  <div>
    <div class="d-flex justify-content-end">
      <div class="d-flex justify-content-between button-group">
        <img v-if="currentRoutePermissions.add_requestorder"
             src="@/assets/images/common-icons/icon_create.svg"
             @click="createRequest"
             :title="$t('buttons.requests.create_request')">
        <img v-if="currentRoutePermissions.delete_requestorder"
             src="@/assets/images/common-icons/icon_delete.svg"
             @click="deleteRequest"
             :title="$t('buttons.requests.delete_request')">
        <img src="@/assets/images/common-icons/icon_clear.png"
             @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg"
             @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.seller')}}</label>
            <multiselect v-model="searchData.sellers" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="sellers" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.contracts.contract_number')}}</label>
            <multiselect v-model="searchData.contracts" :max-height="200"
                         placeholder="" label="contract_nr" track-by="id"
                         :options="contractsList" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.requests.request_number')}}</label>
            <input class="form-control"
                   v-model="searchData.request_nr"
                   @keyup.enter="search"
                   placeholder="">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.supplier')}}</label>
            <multiselect v-model="searchData.suppliers"
                         :max-height="200"
                         placeholder=""
                         label="name"
                         track-by="id"
                         :options="suppliers"
                         :multiple="true"
                         :taggable="true"
                         :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.creation_date')}}</label>
            <range-date-picker v-model="searchData.range_date"
                               range lang="en"
                               placeholder=""
                               range-separator="/"
                               :first-day-of-week="1"></range-date-picker>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.creator')}}</label>
            <multiselect v-model="searchData.creator"
                         :max-height="200"
                         placeholder=""
                         label="username"
                         track-by="id"
                         :options="users"
                         :multiple="true"
                         :taggable="true"
                         :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.buyer')}}</label>
            <multiselect v-model="searchData.buyers" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="customers" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.delivery_date')}}</label>
            <range-date-picker v-model="searchData.delivery_term" range lang="en"
                               placeholder=""
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.currency')}}</label>
            <multiselect v-model="searchData.currencies" :max-height="200"
                         placeholder="" label="code" track-by="code"
                         :options="currencies" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <b-row class="vertical-center-container d-flex justify-content-end">
          <b-col cols="4">
            <label>{{$t('labels.common.transport')}}</label>
            <multiselect v-model="searchData.delivery_methods" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="delivery_methods" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col cols="4">
              <input v-model="searchData.quick_search" class="form-control"
                     placeholder="">
            </b-col>
            <b-col cols="4" offset="4" class="vertical-center-container d-flex justify-content-end">
              <label for="pagination-toggle" class="margin-right-5">{{$t('labels.common.pagination')}}</label>
              <input id="pagination-toggle" type="checkbox"
                     title="this checkbox needed for toggle pagination bar" v-model="paginationState"
                     @change="togglePagination">
              <save-columns-btn :grid="requestOrderGridOptions" :grid-name="gridName"
                                class="margin-left-5"></save-columns-btn>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-row>
            <b-col>
              <ag-grid-vue class="ag-theme-balham grid"
                           :gridOptions="requestOrderGridOptions"
                           :columnDefs="requestOrderColumns"
                           :rowData="requests"
                           @filterChanged="updateTotalData"
                           :pinnedBottomRowData="pinnedRowData"
                           @rowDoubleClicked="goToRequestOrder"
              >
              </ag-grid-vue>
            </b-col>
          </b-row>
          <b-row class="pagination__wrapper" v-if="paginationState">
            <b-col cols="5">
              <div class="pagination-info">{{countOfViewRequests}} {{$t('common_content.of')}} {{requestsCount}}
              </div>
            </b-col>
            <b-col cols="7">
              <b-pagination size="md"
                            :total-rows="requestsCount"
                            :per-page="searchObject.limit"
                            v-model="currentPaginateIndex"
                            @input="changePaginateState"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import {
    mapGetters,
    mapState
  } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import moment from 'moment';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';
  import { updateTotalDataMixin } from '@/mixins'

  export default {
    mixins: [updateTotalDataMixin],
    components: {
      Multiselect,
      RangeDatePicker,
      SaveColumnsBtn,
      'ag-grid-vue': AgGridVue,
    },
    data() {
      return {
        searchData: {
          sellers: [],
          contracts: [],
          delivery_methods: [],
          suppliers: [],
          range_date: '',
          currencies: [],
          buyers: [],
          request_nr: '',
          delivery_term: '',
          creator: [],
          quick_search: ''
        },
        searchObject: {
          limit: 15,
          offset: 0
        },
        paginationState: true,
        currentPaginateIndex: 1
      }
    },
    'searchData.quick_search': {
      deep: true,
      handler () {
        this.setQuickFilter()
      }
    },
    methods: {
      async updateTotalData(event) {
        await this.updateTotalDataWith(event, async (params) => {
          await this.$store.dispatch('requests/updateTotalByFilter', params);
        })
      },
      search() {
        this.currentPaginateIndex = 1;
        this.searchObject = {
          ...this.searchObject,
          sellers: getArrayByProperty(this.searchData.sellers, 'id').toString(),
          contracts: getArrayByProperty(this.searchData.contracts, 'id').toString(),
          delivery_methods: getArrayByProperty(this.searchData.delivery_methods, 'id').toString(),
          suppliers: getArrayByProperty(this.searchData.suppliers, 'id').toString(),
          creation_date_between_after: this.searchData.range_date && this.searchData.range_date[0] ? moment(this.searchData.range_date[0]).format(DATE_FORMAT) : '',
          creation_date_between_before: this.searchData.range_date && this.searchData.range_date[1] ? moment(this.searchData.range_date[1]).format(DATE_FORMAT) : '',
          delivery_term_between_after: this.searchData.delivery_term && this.searchData.delivery_term[0] ? moment(this.searchData.delivery_term[0]).format(DATE_FORMAT) : '',
          delivery_term_between_before: this.searchData.delivery_term && this.searchData.delivery_term[1] ? moment(this.searchData.delivery_term[1]).format(DATE_FORMAT) : '',
          currencies: getArrayByProperty(this.searchData.currencies, 'id').toString(),
          buyers: getArrayByProperty(this.searchData.buyers, 'id').toString(),
          request_nr: this.searchData.request_nr,
          creator: getArrayByProperty(this.searchData.creator, 'id').toString(),
        };
        this.$store.dispatch('requests/loadRequests', this.searchObject);
        saveFilters('purchaseRequests', this.searchData);
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      setQuickFilter(e) {
        this.requestOrderGridOptions.api.setQuickFilter(this.searchData.quick_search);
      },
      changePaginateState() {
        const searchObject = {...this.searchObject, offset: (this.currentPaginateIndex - 1) * this.searchObject.limit};
        this.$store.dispatch('requests/loadRequests', searchObject);
      },
      createRequest() {
        this.$router.push({path: `/requests/new`});
      },
      deleteRequest() {
        const id = getArrayByProperty(this.requestOrderGridOptions.api.getSelectedRows(), 'id');
        if (id.length) {
          this.$http.delete(`purchase/request_orders/`, {body: {id}}).then(() => {
            this.currentPaginateIndex = 1;
            this.$store.dispatch('requests/loadRequests', this.searchObject);
            this.$notify(setNotifyData('Success', 'Request order has been removed!', 'success'));
          }).catch((error) => {
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$notify(setNotifyData('Select request order for removing', '', 'warn'));
        }
      },
      goToRequestOrder(params) {
        if (params.data && params.data.id) {
          this.$router.push({path: `/requests/${params.data.id}`})
        }
      },
      togglePagination() {
        if (!this.paginationState) {
          delete this.searchObject.limit;
          delete this.searchObject.offset;
        } else {
          this.searchObject.limit = 15;
          this.searchObject.offset = 0;
        }
        this.search();
      },
      clearData() {
        this.$store.commit('requests/setRequestsData', []);
      }
    },
    beforeMount() {
      this.$store.dispatch('partners/getSellers');
      this.$store.dispatch('partners/getSuppliers');
      this.$store.dispatch('partners/getCustomers');
      this.$store.dispatch('contracts/loadContractsList');
      this.$store.cache.dispatch('woodware/getUsers');
      this.$store.cache.dispatch('woodware/getDeliveryMethods');
      this.$store.cache.dispatch('generic/getCurrencies');
      if (checkSavedFilterData('purchaseRequests')) {
        this.searchData = setFilters('purchaseRequests');
        this.search();
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    },
    computed: {
      ...mapState('requests', ['gridName']),
      ...mapState('generic', ['currencies', 'currentRoutePermissions']),
      ...mapState('partners', ['suppliers', 'customers', 'sellers']),
      ...mapState('contracts', ['contractsList']),
      ...mapState('woodware', ['delivery_methods', 'users']),
      ...mapState('requests', ['requestOrderColumns', 'requests', 'requestsCount', 'pinnedRowData']),
      ...mapGetters('requests', {
        requestOrderGridOptions: 'requestOrderGridOptions'
      }),
      countOfViewRequests() {
        return this.requests.length;
      }
    }
  }
</script>

<style scoped>

  .grid {
    height: calc(100vh - 460px);
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/requests/RequestList.vue